import { $getNearestNodeFromDOMNode, LexicalEditor } from 'lexical';
import { $isLinkNode } from '@lexical/link';

/**
 * Check if format state should be reset on blur
 */
export const shouldResetOnBlur = (
  payload: FocusEvent,
  editorRootElement: HTMLElement | null
): boolean => {
  const relatedTarget = payload.relatedTarget as HTMLElement;

  const toolbarClicked = document
    .querySelector('bl-editor-toolbar')
    ?.contains(relatedTarget);

  const clickedWithinEditor = editorRootElement?.contains(relatedTarget);

  return !(toolbarClicked || clickedWithinEditor);
};

/**
 * Handle potential link click events
 */
export const handlePotentialLinkClick = (
  target: HTMLElement,
  editor: LexicalEditor,
  onLinkClick: () => void
): void => {
  if (!target) return;

  editor.read(() => {
    const node = $getNearestNodeFromDOMNode(target);
    const isLink = $isLinkNode(node) || $isLinkNode(node?.getParent());

    if (isLink) {
      onLinkClick();
    }
  });
};
